/**
 * @enum ChallengeStatus
 * @description The possible statuses of a challenge
 */
enum ChallengeStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  WINNER = "WINNER",
}

export default ChallengeStatus;
